import { render, staticRenderFns } from "./MemberEmergencyContacts.vue?vue&type=template&id=5ed47ffc"
import script from "./MemberEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./MemberEmergencyContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports